const Community = (communities) => {
    const view = communities.posts
      .map((community) => {
        const imageURL = !community['item-thumbnail']
          ? 'https://via.placeholder.com/654x370'
          : community['item-thumbnail'];
        return `
        <div class="comm-grid-item">
        <div class="comm-grid-item__wrap">
            <div class="comm-grid-item__image"><img src="${imageURL}" alt="${community['item-title']} thumbnail image" srcset=""></div>
            <div class="comm-grid-item__title">${community['item-title']}</div>
            <div class="comm-grid-item__content">${community['item-content']}</div>
        </div>
        <?php if(get_field('gb_link')): ?>
            <div class="comm-grid-item__button"><a class="btn btn--secondary" href="${community['item-permalink']}" target="_blank">Learn More</a></div>
        <?php endif; ?>
    </div>
          `;
      })
      .join('');
  
    return view;
  };
  
  export default Community;
  